import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { BundleCourseState } from "./types";
import BundleCourseService from "@/services/bundleCourse.service";
import { AxiosError, AxiosResponse } from "axios";
const service: BundleCourseService = new BundleCourseService();

export const actions: ActionTree<BundleCourseState, RootState> = {
  getBundleCourse(_, callback: ActionCallback) {
    service
      .getBundleCourse(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getBundleCourseDetail(_, callback: ActionCallback) {
    service
      .getBundleCourseDetail(callback?.params.slug)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getBundleCourseRating(_, callback: ActionCallback) {
    service
      .getBundleCourseRating(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
